import type { Theme } from '@mui/material';

export const styles = {
  metaNavigation: (theme: Theme) => ({
    whiteSpace: 'nowrap',
    display: 'flex',
    padding: 1,
    flexDirection: 'column',
    alignItems: 'start',

    '& .MuiButton-root': {
      textDecoration: 'underline',

      '&:hover': {
        textDecoration: 'underline',
      },
    },

    '& .MuiButton-root, .MuiTypography-root': {
      fontSize: theme.typography.body2,
    },
  }),

  currentUser: (theme: Theme) => ({
    padding: theme.spacing(0.75, 1),
  }),
};
